module.exports = __webpack_public_path__ + "static/media/artist-rush-album-1.a27e2816.jpg";